"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyDocumentSectionWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var React = require("react");
var DocumentListModal_1 = require("../annual/motor/DocumentListModal");
var services_1 = require("@falcon/services");
var journey_services_1 = require("@athena-portal/journey-services");
var PolicyDocumentSectionWidget = /** @class */ (function (_super) {
    __extends(PolicyDocumentSectionWidget, _super);
    function PolicyDocumentSectionWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.navigateToEditRenewal = _this.navigateToEditRenewal.bind(_this);
        return _this;
    }
    PolicyDocumentSectionWidget.prototype.render = function () {
        return (React.createElement("div", { className: "policy-document-section-widget mb-5" }, this.renderPolicyDocumentSection()));
    };
    PolicyDocumentSectionWidget.prototype.renderPolicyDocumentSection = function () {
        var documentVersion = (0, DocumentListModal_1.getDocumentVersionByDate)(new Date(this.props.interaction.factors.originalQuoteDate));
        return (React.createElement("p", null,
            "Open the ",
            React.createElement("a", { target: "_blank", download: "Allianz Car Document of Insurance (DOI)", href: "/resources/documents/LV_Allianz_Annual_Car/".concat(documentVersion, "/LV_Allianz_Annual_Car_DOI_").concat(documentVersion, ".pdf") }, "policy document"),
            " ",
            this.renderPolicyDocumentWording()));
    };
    PolicyDocumentSectionWidget.prototype.renderPolicyDocumentWording = function () {
        return (this.isMTCRenewal()
            ? React.createElement(React.Fragment, null,
                "or go to ",
                React.createElement("button", { className: "buttonLink", onClick: this.navigateToEditRenewal }, "\u201CYour renewal, make changes\u201D"),
                " to see full cover details")
            : React.createElement(React.Fragment, null, "to see full cover details"));
    };
    PolicyDocumentSectionWidget.prototype.navigateToEditRenewal = function () {
        journey_services_1.ObjectManipulator.setField("uistate.interactionChangesDetected", this.props.interaction, true);
        this.props.engine.navigate("viewAndEditRenewalProposalPage", false);
    };
    PolicyDocumentSectionWidget.prototype.isMTCRenewal = function () {
        var referrerJourney = this.getSetting("referrerJourney", "");
        return referrerJourney === services_1.INTERACTION_PROCESS_RENEWAL_CANCELLATION;
    };
    return PolicyDocumentSectionWidget;
}(plugin_journey_1.WidgetBase));
exports.PolicyDocumentSectionWidget = PolicyDocumentSectionWidget;
//# sourceMappingURL=PolicyDocumentSectionWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/motorCommon/PolicyDocumentSectionWidget.js
// module id = 3239
// module chunks = 0